import { render } from "./HeaderUserArea.vue?vue&type=template&id=6d6b7227&lang=html"
import script from "./HeaderUserArea.vue?vue&type=script&lang=js"
export * from "./HeaderUserArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__